@if (show()) {
    <div class="font-medium text-base break-words text-custom-text-grey">
        <app-select
            [canClear]="false"
            [defaultValue]="selectedProject() ? [{ label: selectedProject()!.name, value: selectedProject()! }] : []"
            [isMultiSelect]="false"
            [options]="projectOptions()"
            [placeholder]="selectedProject()?.name ?? 'createProject'"
            (optionSelected)="onOptionSelected($event)">
            <ng-template
                #selectedPrefix
                let-opt>
                <fa-icon
                    class="mr-4"
                    matListItemIcon
                    size="xs"
                    [icon]="['fas', 'circle-small']"
                    [style.color]="opt?.value?.color ?? defaultProjectColor" />
            </ng-template>

            <ng-template
                #optionPrefix
                let-opt>
                <fa-icon
                    class="mr-4"
                    matListItemIcon
                    size="xs"
                    [icon]="['fas', 'circle-small']"
                    [style.color]="opt?.value?.color ?? defaultProjectColor" />
            </ng-template>

            <ng-template #bottomOption>
                <div
                    *hasSomePermissions="[PermissionAliasEnum.MANAGE_PROJECT]"
                    class="!sticky bottom-0 !bg-white cursor-pointer footer footer-shadow"
                    (click)="handleCreateProject()">
                    <span class="flex align-middle create-project-option">
                        <fa-icon
                            class="mr-3"
                            matListItemIcon
                            [icon]="['fas', 'plus']" />
                        <span>{{ 'createProject' | transloco }}</span>
                    </span>
                </div>
            </ng-template>
        </app-select>
    </div>
}
